import { useNavigate } from "react-router-dom";
import { BiXCircle } from "react-icons/bi";
import { ROUTES } from "../../../helpers/constants";
import { PAYMENT_STRINGS } from "../../private/payment-result/strings";
import PublicLayout from "../../../layout/public-layout";

const strings = PAYMENT_STRINGS.failureGuest;

const PaymentFailureGuest = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate(ROUTES.PUBLIC_CHECKOUT.route);
  };

  return (
    <PublicLayout>
      <div className="gm-clients-details-container">
        <div className="gm-folder-container" style={{ marginTop: 40, display: "flex", flexDirection: "column", alignItems: "center" }}>
          <BiXCircle size={56} color="#d32f2f" style={{ marginBottom: 16 }} aria-label="Error" role="img" />
          <h2 style={{ fontWeight: 500, fontSize: 22, marginBottom: 0 }}>{strings.title}</h2>
          <p style={{ color: "#666", marginTop: 12, marginBottom: 32 }}>
            {strings.description}
          </p>
          <button
            type="button"
            className="gm-primary-button"
            style={{ padding: "10px 16px", width: 180 }}
            onClick={handleRetry}
          >
            {strings.retryButton}
          </button>
        </div>
      </div>
    </PublicLayout>
  );
};

export default PaymentFailureGuest;
